import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import {
  emailValidator,
  nameSurnameValidator,
  phoneValidator,
  ocNumberOrRelation,
  registrationNumberValidatorOrRelation,
} from "../../../../../utilities/validators";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.INTRODUCTORY_PERPETRATOR]: yup.object({
    [ComponentId.PERPETRATOR_REGISTRATION_NUMBER]: registrationNumberValidatorOrRelation,
    [ComponentId.PERPETRATOR_OC_NUMBER]: ocNumberOrRelation,
    [ComponentId.PERPETRATOR_NAME]: nameSurnameValidator,
    [ComponentId.PERPETRATOR_SURNAME]: nameSurnameValidator,
    [ComponentId.PERPETRATOR_PHONE]: phoneValidator("perpetratorphone"),
    [ComponentId.PERPETRATOR_EMAIL]: emailValidator,
  }),
};
